// Auto-generated normalizer for table: Personas
export function personasNormalize(row) {
  return {
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    apellidoPaterno: row.apellidoPaterno ?? row.ApellidoPaterno ?? row['ApellidoPaterno'] ?? '',
    apellidoMaterno: row.apellidoMaterno ?? row.ApellidoMaterno ?? row['ApellidoMaterno'] ?? '',
    curp: row.curp ?? row.Curp ?? row.CURP ?? row['CURP'] ?? '',
    rfc: row.rfc ?? row.Rfc ?? row.RFC ?? row['RFC'] ?? '',
    genero: row.genero ?? row.Genero ?? row['Genero'] ?? '',
    fechaNacimiento: row.fechaNacimiento ?? row.FechaNacimiento ?? row['FechaNacimiento'] ?? null,
    fechaRegistro: row.fechaRegistro ?? row.FechaRegistro ?? row['FechaRegistro'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fotoPerfil: row.fotoPerfil ?? row.FotoPerfil ?? row['FotoPerfil'] ?? '',
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row['IdEmpresa'] ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? row['NombreEmpresa'] ?? '',
  };
}
